import React from "react";
import { Button, StatusStepper, TextInput } from "@pickit/pickit-components";
import { Field, Form } from "react-final-form";
import "./detailPreliquidation.scss";
import { DetailPreliquidationPropsType } from "./types";
import { Transactions } from "./transactions/Transactions";
import { ISO8601toDDMMYYYHHMM } from "utils/date";
import "./i18n";
import { useTranslation } from "react-i18next";
import { PreliHistoryType } from "reducers/types/preliquidation";
import { PRELIQUIDATION_STATUS } from "utils/constants";

export const DetailPreliquidation = ({
  preliquidation,
  initialValues,
  toggleModalVisibility,
  testId,
}: DetailPreliquidationPropsType) => {
  const { t } = useTranslation();
  return (
    <div>
      <Form onSubmit={(value) => value} initialValues={initialValues}>
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <div className="display-filter detail-preliquidation">
              <div className="container-detail-preliquidation-form-row">
                <div className="container-detail-preliquidation-form-col-sm-2 container-detail-preliquidation-form-col-lg-1">
                  <Field
                    name="status"
                    label={t("presettlement:status")}
                    component={TextInput}
                    disabled={true}
                    testId={`${testId}-field-status`}
                    placeholder="-"
                    showClearIcon={false}
                  />
                </div>
                <div className="container-detail-preliquidation-form-col-sm-2 container-detail-preliquidation-form-col-lg-1">
                  <Field
                    label={t("presettlement:emisionDate")}
                    name="emisionDate"
                    component={TextInput}
                    disabled={true}
                    placeholder="-"
                    testId={`${testId}-field-emision-date`}
                    showClearIcon={false}
                  />
                </div>
                <div className="container-detail-preliquidation-form-col-sm-2 container-detail-preliquidation-form-col-lg-1">
                  <Field
                    name="fiscalNumber"
                    label={t("presettlement:fiscalNumber")}
                    component={TextInput}
                    disabled={true}
                    placeholder="-"
                    testId={`${testId}-field-fiscal-number`}
                    showClearIcon={false}
                  />
                </div>
                <div className="container-detail-preliquidation-form-col-sm-2 container-detail-preliquidation-form-col-lg-1">
                  <Field
                    label={t("presettlement:companyName")}
                    name="companyName"
                    component={TextInput}
                    placeholder="-"
                    disabled={true}
                    testId={`${testId}-field-company-name`}
                    showClearIcon={false}
                  />
                </div>
                <div className="container-detail-preliquidation-form-col-sm-2 container-detail-preliquidation-form-col-lg-1">
                  <Field
                    name="sapCode"
                    label={t("presettlement:sapCode")}
                    component={TextInput}
                    disabled={true}
                    testId={`${testId}-field-sap-code`}
                    placeholder="-"
                    showClearIcon={false}
                  />
                </div>
                <div className="container-detail-preliquidation-form-col-sm-2 container-detail-preliquidation-form-col-lg-1">
                  <Field
                    name="region"
                    label={t("presettlement:region")}
                    component={TextInput}
                    disabled={true}
                    testId={`${testId}-field-region`}
                    placeholder="-"
                    showClearIcon={false}
                  />
                </div>
              </div>
            </div>
          </form>
        )}
      </Form>
      <div className="detail-preliquidation-container-card">
        <div className="container-detail-preliquidation-card-row">
          <div className="container-detail-preliquidation-card-col-sm-5 container-detail-preliquidation-card-col-xl-4">
            <h2 data-testId={`${testId}-history-title`}>
              {t("presettlement:history")}
            </h2>
            <div className="display-card-preliquidation relative">
              <div className="preliquidation-history-container">
                <StatusStepper
                  width="100%"
                  status={preliquidation.histories.map(
                    (state: PreliHistoryType) => {
                      return {
                        status: "success",
                        title: state.title,
                        subtitle: ISO8601toDDMMYYYHHMM(state.createdAt),
                        content: state.description,
                      };
                    }
                  )}
                  testId={testId}
                />
              </div>
              <div className="history-footer-transparent" />
            </div>
          </div>
          <div className="container-detail-preliquidation-card-col-sm-7 container-detail-preliquidation-card-col-xl-5">
            <div className="preliquidation-transactions-header">
              <h2 data-testId={`${testId}-transactions-title`}>
                {t("presettlement:trips")}
              </h2>
              <Button
                testId={`${testId}-button-change-amount`}
                label={t("presettlement:changeAmount")}
                size="medium"
                width="220"
                hierarchy="secondary"
                disabled={preliquidation.status !== PRELIQUIDATION_STATUS.INITIAL}
                onClick={() => {
                  toggleModalVisibility(true);
                }}
                iconName="pencil"
              />
            </div>
            <div className="display-card-preliquidation">
              <Transactions
                total={preliquidation.total}
                trips={preliquidation.trips}
                adjustments={preliquidation.adjustments}
                testId={testId}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
